var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{attrs:{"gutter":20}},_vm._l((_vm.msData),function(item,index){return _c('el-col',{key:index,attrs:{"xs":12,"sm":12,"md":8,"lg":8}},[_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":item.url}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.des))])])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.13.3.0@vue-loader/lib/template-compiler?{"id":"data-v-4ea79550","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.13.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/ms.vue
// module id = kSRX
// module chunks = 1